import { css } from 'styled-components';

export type ButtonMixinProps = {
  primary?: boolean;
  secondary?: boolean;
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  rect?: boolean;
};

const buttonMixin = css<ButtonMixinProps>`
  display: inline-block;

  ${({ theme }) => theme.button.font}
  border: none;

  cursor: pointer;
  transition: ${({ theme }) => theme.button.transition};

  font-size: 16px;
  line-height: 20px;
  padding: 13px 20px;
  border-radius: ${({ rect, theme }) => (rect ? theme.borderRadius.md : '24px')};

  ${({ xs, rect, theme }) =>
    xs &&
    css`
      font-size: 12px;
      line-height: 14px;
      padding: 4px 9px;
      border-radius: ${rect ? theme.borderRadius.sm : '12px'};
    `}

  ${({ sm, rect, theme }) =>
    sm &&
    css`
      font-size: 12px;
      line-height: 14px;
      padding: 8px 13px;
      border-radius: ${rect ? theme.borderRadius.sm : '16px'};
    `}

  ${({ md, rect, theme }) =>
    md &&
    css`
      font-size: 16px;
      line-height: 20px;
      padding: 9px 16px;
      border-radius: ${rect ? theme.borderRadius.md : '20px'};
    `}

  ${({ secondary }) =>
    secondary &&
    css`
      border: 1px solid ${({ theme }) => theme.button.borderColor.secondary};
      &,
      &:focus {
        background-color: #ffffff;
        color: ${({ theme }) => theme.button.borderColor.secondary};
      }
    `}

  ${({ primary }) =>
    primary &&
    css`
      border: 1px solid ${({ theme }) => theme.button.borderColor.primary};
      &,
      &:focus {
        background: ${({ theme }) => theme.button.background.primary};
        color: #ffffff;
      }
    `}

  &:hover {
    background: ${({ theme }) => theme.button.background.hover} no-repeat;
    border-color: ${({ theme }) => theme.button.borderColor.hover};
    color: #ffffff;
  }

  &:focus {
    border-color: ${({ theme }) => theme.button.borderColor.focus} !important;
  }

  &:active, &:active:focus, &:active:hover {
    background: ${({ theme }) => theme.button.background.click} no-repeat;
    border-color: ${({ theme }) => theme.button.borderColor.hover};
    color: #ffffff;
  }

  &:disabled, &:disabled:hover, &:disabled:active {
    transform: none;
    border: 1px solid ${({ theme }) => theme.button.borderColor.disabled};
    background: ${({ theme }) => theme.button.background.disabled};
    color: #ffffff;
  }
`;

export default buttonMixin;
